import { render, staticRenderFns } from "./sponsorship_pre_dependent.vue?vue&type=template&id=47429328&"
import script from "./sponsorship_pre_dependent.vue?vue&type=script&lang=js&"
export * from "./sponsorship_pre_dependent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports